import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import styles from './ForgotPassword.module.css';
import { authService } from '../../../services/api';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  
  // Determine the role based on the current URL path
  const currentPath = window.location.pathname;
  const isHomeOwnerPath = currentPath.startsWith('/homeowner');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await authService.forgotPassword({ email });

      if (response.data.status === 'success') {
        navigate('/verify', {
          state: {
            email,
            nextStep: 'reset-password',
            message: 'Please check your email for the verification code.',
            role: isHomeOwnerPath ? 'homeowner' : 'user'
          }
        });
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to process request');
    } finally {
      setLoading(false);
    }
  };
  
  // Get the appropriate login path based on role
  const loginPath = isHomeOwnerPath ? '/homeowner/login' : '/login';

  return (
    <div className={styles.authContainer}>
      <div className={styles.authBackground}>
        <div className={styles.shape}></div>
        <div className={styles.shape}></div>
        <div className={styles.shape}></div>
      </div>

      <div className={styles.authCard}>
        <div className={styles.authHeader}>
          <div className={styles.lockIcon}>
            <i className="fas fa-lock"></i>
          </div>
          <h2 className={styles.title}>Reset Password</h2>
          <p className={styles.authSubtitle}>
            Enter your email address and we'll send you a verification code
          </p>
        </div>

        {success && (
          <div className={styles.success}>
            <i className="fas fa-check-circle"></i>
            {success}
          </div>
        )}
        
        <form onSubmit={handleSubmit} className={styles.authForm}>
          <div className={styles.formGroup}>
            <div className={styles.inputWrapper}>
              <i className="fas fa-envelope"></i>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="Enter your email"
              />
            </div>
          </div>

          {error && (
            <div className={styles.error}>
              <i className="fas fa-exclamation-circle"></i>
              {error}
            </div>
          )}

          <button 
            type="submit" 
            className={`${styles.authButton} ${loading ? styles.loading : ''}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <div className={styles.spinner}></div>
                <span>Sending...</span>
              </>
            ) : (
              <>
                <span>Send Reset Code</span>
                <i className="fas fa-paper-plane"></i>
              </>
            )}
          </button>
        </form>

        <div className={styles.authLinks}>
          <div className={styles.divider}>
            <span>or</span>
          </div>
          <p className={styles.authRedirect}>
            Remember your password?{' '}
            <Link to={loginPath}>Back to Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 